<div id="arclive-phonebox" ng-draggable ng-draggable-resize="false" class="phonebox">

  <!-- Header -->
  <div class="phonebox-header">
    <i class="fa fa-phone fa-2x phonebox-icon"></i>
    <div class="phonebox-title-wrapper">
      <span class="phonebox-title">{{toUserFullName}}</span>
      <span class="phonebox-subtitle">({{toCompanyName}})</span>
    </div>
    <i class="fa fa-times fa-2x phonebox-close" (click)="activeModal.dismiss()" title="Close window"></i>
  </div>

  <!-- Main Content -->
  <div id="phonebox-main" class="phonebox-main">
    <div ng-if="data.deviceReady()" class="phonebox-content">
      <!-- Phone dropdown -->
      @if (user.phones.length) {
        <select class="form-select" [(ngModel)]="selectedPhone"
          (ngModelChange)="onPhoneChange($event)">
          @for (phone of user.phones; track phone) {
            <option [ngValue]="phone">
              {{ phone.number }} ({{ phone.type }})
            </option>
          }
        </select>
      }

      <!-- Call Controls -->
      <div class="phonebox-controls">
        <span class="phonebox-number">{{phone}}</span>
        <div class="phonebox-actions">
          <!-- Disconnected -->
          @if (isDisconnected()) {
            <button class="btn btn-primary phonebox-btn" (click)="connect()">
              Call
            </button>
          }

          <!-- Connecting -->
          @if (isConnecting()) {
            <button class="btn btn-warning phonebox-btn" (click)="disconnect()">
              Cancel
            </button>
          }
          @if (isConnecting()) {
            <span class="phonebox-status calling">
              Calling...
            </span>
          }

          <!-- Connected -->
          @if (isConnected()) {
            <button class="btn btn-danger phonebox-btn" (click)="disconnect()">
              Disconnect
            </button>
          }
          @if (isConnected()) {
            <span class="phonebox-status connected">
              Connected
            </span>
          }
        </div>
      </div>

      <!-- Mute Control -->
      <!-- <div *ngIf="isConnected()" class="phonebox-mute">
      <img *ngIf="isMuted()" src="img/microphone-slash.png" (click)="toggleMute(false)"
        class="phonebox-mute-icon" title="Click to unmute">
        <img *ngIf="!isMuted()" src="img/microphone.png" (click)="toggleMute(true)" class="phonebox-mute-icon"
          title="Click to mute">
        </div> -->
      </div>
    </div>

  </div>